import { useDispatch } from 'react-redux';

import { useNavigate } from 'react-router-dom';

import { MODULE_NAME, TASKTYPE } from 'common/constants';
import {
	PROGRESS_BAR_ELEMENTS,
	STATUS_UPDATE_TYPE,
} from 'common/constants/CitationDetails';
import { HTTP_STATUS_CODES } from 'common/constants/HttpStatusConstants';
import { rrcpDashboardRoutes } from 'common/constants/rrcp-dashboard-routes';
import {
	AXIOS_NETWORK_ERR_CODE,
	submissionFailedMsg,
} from 'common/constants/TextContent';
import { setToastMessage } from 'common/store/reducer/commonReducer';
import { urlWithTenant, removeHTMLTags } from 'common/utils/utilFunctions';

import { postMappingGenerate, updateCitationWithSummary } from '../api';
import RegInventorySummaryAndMapping, {
	IRegulationInventorySummaryElements,
} from '../Components/SummaryAndMappingComponents/SummaryAndMapping';

const { REQUIREMENT_INVENTORY_NAME } = MODULE_NAME;

const { OK, CREATED } = HTTP_STATUS_CODES;

const { regulationInventory, overView } = rrcpDashboardRoutes;

interface IRegulationInventorySummaryProps {
	storageWrapper: any;
}
const RegulationInventorySummary = (
	props: IRegulationInventorySummaryProps,
) => {
	const { storageWrapper } = props;

	const dispatch = useDispatch();
	const navigate = useNavigate();

	const updateTaskStatusWithSummary = async (
		values: IRegulationInventorySummaryElements,
	) => {
		const { status, summaryAssessment, summaryText, actionType } = values;
		const data: any = {
			taskId: summaryAssessment?.taskId,
			groupId: summaryAssessment?.groupId,
			summary: summaryText,
			taskType: TASKTYPE.WORKFLOW,
			moduleName: REQUIREMENT_INVENTORY_NAME,
			actionType,
			taskStatus: status,
		};

		if (
			status === PROGRESS_BAR_ELEMENTS.MAPPING_ASSESSMENT &&
			actionType === STATUS_UPDATE_TYPE.APPROVE
		) {
			const postData = {
				parentObjectId: summaryAssessment?.groupId,
				text: removeHTMLTags(summaryText),
				type: '',
			};
			postMappingGenerate(postData);
		}
		const resp = await updateCitationWithSummary(data);
		if (resp?.statusCode === OK || resp?.statusCode === CREATED) {
			dispatch(
				setToastMessage({
					message: 'The details saved successfully',
					severity: 'success',
					isToastOpen: true,
				}),
			);
			navigate(urlWithTenant(`/${regulationInventory}/${overView}`));
		}
		if (resp?.errorBody || resp?.error) {
			const { errorBody } = resp;
			const responseError: any = resp.error;
			let errorMessage =
				(errorBody?.errorMessage as string) ||
				(responseError?.message as string);
			if (responseError?.code === AXIOS_NETWORK_ERR_CODE) {
				errorMessage = submissionFailedMsg;
			}
			dispatch(
				setToastMessage({
					message: errorMessage,
					severity: 'error',
					isToastOpen: true,
				}),
			);
		}
	};
	return (
		<RegInventorySummaryAndMapping
			submitHandlerForSummary={(values: IRegulationInventorySummaryElements) =>
				updateTaskStatusWithSummary(values)
			}
			storageWrapper={storageWrapper}
		/>
	);
};

export default RegulationInventorySummary;
